import { render, staticRenderFns } from "./IconAlphaVerify.vue?vue&type=template&id=073fedd5&"
import script from "./IconAlphaVerify.vue?vue&type=script&lang=js&"
export * from "./IconAlphaVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports